<template>
    <div class="px-8 mt-5">

        <VueSlickCarousel v-bind="settings">
            <InstagramCard v-for="i in 6" :key="i"/>
            <template #prevArrow="arrowOption">
                <div class="carousel-arrow prev-arrow"></div>
            </template>
            <template #nextArrow="arrowOption">
                <div class="carousel-arrow next-arrow"></div>
            </template>
        </VueSlickCarousel>

    </div>
</template>

<script>

    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

    import InstagramCard from './cards/Instagram';

    export default {
        name: 'InstagramCarousel',
        components: {VueSlickCarousel,InstagramCard},

        data() {
            return {
                settings: {
                    "arrows": true,
                    "focusOnSelect": true,
                    "infinite": true,
                    "speed": 500,
                    "slidesToShow": 4,
                    "slidesToScroll": 3,
                    "touchThreshold": 5
                }
            }
        },

        created() {
            console.log('created');
        }
    }

</script>
